import { getItemFromCollection } from "directus/src/operations";

export async function fetchBookmarkDataForForm({ id }) {
    try {
        const query = {
            fields: [
                "id",
                "label",
                "url",
                "description",
                "bookmark",
            ],
        };
        const response = await getItemFromCollection("bookmark_links", id, query);
        return response;
    } catch (error) {
        console.error(error);
        throw error;
    }
}